import React, { useEffect } from 'react';
import { Cpu, Car, Plane, Factory, Radio, Smartphone, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Container, EyebrowLabel, SectionTitle } from '../components/Section';
import HeroBanner from '../components/HeroBanner';
import { industries } from '../mock';

const iconMap = { semiconductor: Cpu, automotive: Car, aerospace: Plane, industrial: Factory, consumer: Smartphone, telecom: Radio };

export default function Industries() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="bg-[#FAF7F5]">
      <HeroBanner
        image="/hero/industries.jpg"
        overlay="default"
        height="min-h-[460px] lg:min-h-[540px]"
      >
        <div className="pt-[120px] lg:pt-[140px] pb-14 lg:pb-16">
          <Container>
            <div className="erbity-fade-up">
              <EyebrowLabel>Industries</EyebrowLabel>
              <SectionTitle as="h1" className="mt-6 text-[44px] lg:text-[68px] leading-[1.04] max-w-4xl">
                Talent tuned to the toughest <span className="italic text-[#7E2E4A]">engineering</span> sectors.
              </SectionTitle>
              <p className="mt-6 text-[17px] text-[#3B333A] max-w-2xl leading-relaxed erbity-fade-up-1">
                We partner with companies designing at the edge of physics &mdash;
                from 3nm SoCs to safety-critical avionics. Below are the sectors where
                our talent pools run deepest.
              </p>
            </div>
          </Container>
        </div>
      </HeroBanner>

      <section className="pb-32">
        <Container>
          <div className="grid md:grid-cols-2 gap-5">
            {industries.map((ind, i) => {
              const Icon = iconMap[ind.id] || Cpu;
              return (
                <div key={ind.id} className="group relative bg-white rounded-3xl overflow-hidden border border-[#EADDE2] hover:border-[#C4506F] transition-colors">
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={ind.image}
                      alt=""
                      className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      style={{ filter: 'saturate(0.9) brightness(0.94)' }}
                    />
                    <div className="absolute inset-0" style={{ background: 'linear-gradient(180deg, rgba(20,16,26,0) 40%, rgba(20,16,26,0.5) 100%)' }} />
                    <div className="absolute inset-0" style={{ background: 'radial-gradient(70% 70% at 85% 85%, rgba(196,80,111,0.35), transparent 65%)' }} />
                    <div className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.22em] text-white/85">0{i + 1}</div>
                    <div className="absolute bottom-4 left-4 w-11 h-11 rounded-xl bg-white/95 backdrop-blur flex items-center justify-center text-[#7E2E4A] shadow-sm">
                      <Icon size={20} />
                    </div>
                  </div>
                  <div className="p-8 lg:p-10">
                    <h3 className="font-serif text-[28px] lg:text-[32px] text-[#1A1420]" style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}>{ind.name}</h3>
                    <p className="mt-3 text-[15px] text-[#4E434A] leading-relaxed">{ind.blurb}</p>
                    <div className="mt-6 flex flex-wrap gap-2">
                      {ind.tags.map((t) => (
                        <span key={t} className="text-[12px] px-3 py-1.5 rounded-full bg-[#FAF7F5] border border-[#EADDE2] text-[#4E434A]">{t}</span>
                      ))}
                    </div>
                    <Link to="/contact" className="mt-8 inline-flex items-center gap-2 text-[14px] text-[#1A1420] border-b border-[#1A1420]/30 group-hover:border-[#7E2E4A] pb-1">
                      Discuss {ind.name.split(' ')[0].toLowerCase()} hiring <ArrowUpRight size={14} />
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>
      </section>
    </div>
  );
}
